import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className={
        'justify-content-center'
      }
    >
      <Outlet />
    </div>
  );
}
